export const expostProjectToTable = (expostProject) => {
  if (!Array.isArray(expostProject) || expostProject.length === 0) return {};

  const project = expostProject[0];

  // eslint-disable-next-line no-unused-vars
  const { uuid, intervention_zone_id, prediction, ...filteredExpostProject } = project;

  return Object.keys(filteredExpostProject).reduce((acc, key) => {
    acc[key] = Array.isArray(filteredExpostProject[key])
      ? filteredExpostProject[key].map(item => ({ ...item, saved: true }))
      : filteredExpostProject[key];

    return acc;
  }, {});
};